import React from "react";
import ServiceBookingsModule from "./ServicesBookings/ServiceBookingsModule";
import ServiceBookingsSagas from "./ServicesBookings/redux/serviceBookingsSagas";
import ServiceBookingsReducer from "./ServicesBookings/redux/serviceBookingsReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Services",
  moduleList: [
    {
      Component: ServiceBookingsModule,
      moduleName: "serviceBookings",
      saga: ServiceBookingsSagas(),
      reducer: ServiceBookingsReducer
    }
  ],
  hideConfigurator: true
};

const ServicePage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default ServicePage;
